import React, { useEffect } from 'react'
import './contact.css';
import { useInView } from 'react-intersection-observer';
import Linkedin from "../../assets/linkedin.png";
import Mail from "../../assets/mail.png";
import Github from "../../assets/github.png";

export default function Contact() {

  return (
    <section id='Contact'>
        <div className='contact-content'>
            <div className='contact-title'>
            <span className='contact-title1'>Got a project idea or just want to say hi?</span>
            <span className='contact-title2'> Let’s connect!</span>
            </div>
            <div className='contact-main'>
              <div className='contact-links'>
                <div className='contact-linkedin'>
                  <a href="https://www.linkedin.com/in/ruhanimittal/">
                    <img src={Linkedin} alt="Linkedin" className='contact-linkedin-img'/>
                  </a>
                  <span className='contact-linkedin-text'>Connect on LinkedIn!</span>
                </div>
                <div className='contact-mail'>
                  <a href="mailto:ruhanimttl@gmail.com">
                    <img src={Mail} alt="mail" className='contact-mail-img'/>
                  </a>
                  <span className='contact-mail-text'>Drop a message!</span>
                </div>
                <div className='contact-github'>
                  <a href="https://github.com/RuhaniMittal29">
                    <img src={Github} alt="github" className='contact-github-img'/>
                  </a>
                  <span className='contact-github-text'>Check out my projects!</span>
                </div>
              </div>
              <div className='contact-form'>
                <form className='form'>
                    <div className='name-email'>
                      <input type="text" placeholder='Name' className='input-field'/>
                      <input type="email" placeholder='Email' className='input-field'/>
                    </div>
                    <input type="subject" placeholder='Subject' className='input-field3'/>
                    <textarea rows="4" placeholder='Message' className='input-field2'></textarea>
                    <button type="submit" className='submit-button'>Submit</button>
                </form>
              </div>
            </div>
        </div>
    </section>
  )
}